import React from 'react';
import { Box, Typography } from '@mui/material';
import { BANNER_VARIANT } from './tokens';

/**
 * Gradient page-description banner matching the V2 mockup style.
 *
 * Variants map to the colour palette used per panel:
 *   - "warning" (orange/red gradient)  → MissedRepeat
 *   - "danger"  (pink/red gradient)    → NeedsAction
 *   - "info"    (purple/indigo)        → ABDConsigneeTagging
 *   - "amber"   (amber/orange)         → MissReasonSettings warning
 */
export default function PageBanner({ variant = 'info', icon, title, children }) {
    const v = BANNER_VARIANT[variant] || BANNER_VARIANT.info;
    // Sample banner spec: padding 16px 20px, border-radius 10px, gap 14px,
    // icon 40×40 radius 10px, title 13px fw 700, body 12px
    return (
        <Box
            sx={{
                background: v.bg,
                borderRadius: '10px',
                padding: '16px 20px',
                mb: '18px',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                border: `1px solid ${v.border}`,
            }}
        >
            <Box
                sx={{
                    bgcolor: v.iconBg,
                    color: '#fff',
                    width: 40,
                    height: 40,
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    '& svg': { fontSize: 20 },
                }}
            >
                {icon}
            </Box>
            <Box>
                <Typography sx={{ fontWeight: 700, fontSize: '13px', color: v.titleColor, mb: '2px' }}>
                    {title}
                </Typography>
                <Typography sx={{ fontSize: '12px', color: v.bodyColor, lineHeight: 1.45 }}>
                    {children}
                </Typography>
            </Box>
        </Box>
    );
}
